/*
 ** TailwindCSS Configuration File
 **
 ** Docs: https://tailwindcss.com/docs/configuration
 ** Default: https://github.com/tailwindcss/tailwindcss/blob/master/stubs/defaultConfig.stub.js
 */
const plugin = require('tailwindcss/plugin');
module.exports = {
  theme: {
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem'
    },
    fontFamily: {
      display: ['urbane', 'sans-serif'],
      sans: ['acumin-pro', 'sans-serif']
    },
    screens: {
      sm: {
        max: '640px'
      },
      'sm-md': {
        max: '767px'
      },
      md: {
        min: '640px',
        max: '767px'
      },
      lg: {
        min: '768px',
        max: '1279px'
      },
      xl: {
        min: '1280px'
      }
    },
    extend: {
      colors: {
        current: 'currentColor',
        primary: '#00ffa6',
        disclosure: '#a5a5a5',
        gray: {
          50: '#f6f6f6',
          100: '#f0f0f0',
          200: '#e6e6e6',
          300: '#dcdcdc',
          400: '#d2d2d2',
          500: '#b9b9b9',
          600: '#8c8c8c',
          700: '#6e6e6e',
          800: '#505050',
          900: '#373737',
          1000: '#1e1e1e'
        },
        green: {
          100: '#e8f5f2',
          200: '#d3f5ed',
          300: '#affddb',
          400: '#36faa5',
          500: '#26ecbc',
          600: '#1cd0a5',
          700: '#1a997b',
          800: '#0c6550',
          900: '#043f31',
          1000: '#01140f'
        },
        cyan: {
          100: '#e6f7f6',
          200: '#d8f0ee',
          300: '#affdf8',
          400: '#86fcf5',
          500: '#36faee',
          600: '#0bd5c9',
          700: '#09aaa1',
          800: '#078079',
          900: '#03403c',
          1000: '#032825'
        },
        'secondary-green': {
          100: '#edfbec',
          200: '#dbf7da',
          300: '#ccffca',
          400: '#b3ffb1',
          500: '#91ff8e',
          600: '#4ad746',
          700: '#1a9f37',
          800: '#0b6e21',
          900: '#0b6e21',
          1000: '#032d0c'
        },
        red: {
          100: '#fff0f1',
          200: '#ffe0e2',
          300: '#ffbabe',
          400: '#ff9ba1',
          500: '#ff7880',
          600: '#ff3340',
          700: '#d12c36',
          800: '#ae242c',
          900: '#7e181e',
          1000: '#551014'
        },
        'cool-gray': {
          100: '#f0f5fa',
          200: '#e9f2f8',
          300: '#e6e6e',
          400: '#d5dee4',
          500: '#cbd4da',
          600: '#b2bbc1',
          700: '#858e94',
          800: '#677076',
          900: '#30393f',
          1000: '#172026'
        },
        orange: {
          100: '#fff4ec',
          200: '#ffecde',
          300: '#ffd2b2',
          400: '#ffc296',
          500: '#ffb078',
          600: '#ff9d57',
          700: '#f2734b',
          800: '#d8573b',
          900: '#b74026',
          1000: '#711b08'
        },
        yellow: {
          100: '#fcf5e9',
          200: '#fcf1de',
          300: '#ffe0b2',
          400: '#ffc978',
          500: '#fdba55',
          600: '#ffa928',
          700: '#de851c',
          800: '#cc6d15',
          900: '#ac580a',
          1000: '#884302'
        },
        blue: {
          100: '#e8f3f9',
          200: '#d4e9f5',
          300: '#aae4f4',
          400: '#75d2ed',
          500: '#25b7e1',
          600: '#1c87c1',
          700: '#166993',
          800: '#115374',
          900: '#0d3d59',
          1000: '#071f2b'
        }
      },
      width: {
        'min-content': 'min-content',
        'max-content': 'max-content'
      },
      maxWidth: {
        xxs: '14rem'
      }
    }
  },
  plugins: [require('@tailwindcss/aspect-ratio'), plugin(function ({
    addVariant,
    e
  }) {
    // add a class like light:text-gray-700
    addVariant('light', ({
      modifySelectors,
      separator
    }) => {
      modifySelectors(({
        selector,
        className
      }) => ':root.theme-light ' + selector.replace(className, e(`light${separator}${className}`)));
    });
  })],
  content: ['./assets/**/*.{vue,js,css}', './components/**/*.{js,vue,ts}', './layouts/**/*.vue', './pages/**/*.vue', './plugins/**/*.{js,ts}', './nuxt.config.{js,ts}']
};